import React, { useState } from 'react';
import { Flex } from "antd";
import { clrs } from "../../constants/colors";
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import back from "../../images/back@3x.png";
import { Fade } from "react-awesome-reveal";
import Header from "../components/DataPage/Header";
import DataTable2 from "../components/DataPage/DataTable2";
import ArchiveView from "../components/DataPage/ArchiveView";


const DataPage = () => {
    const [isActual, setActual] = useState(true); // Start with actual data (DataTable2)


    return (
        <Flex style={{
            width: "100%",
            minHeight: "100vh",
            position: "relative",
            backgroundImage: `url(${back})`,
            backgroundPosition: "center",
            backgroundSize: "cover"
        }} vertical align={"center"} justify={"flex-start"} gap={30}>
            <Header/>
            <Flex style={{width: "calc(100% - 50px)", maxWidth: "1440px", padding: "0px 25px", position: "relative"}}
                  vertical gap={20}>
                <Flex style={{width: "100%"}} align={"center"} justify={"flex-start"} gap={30}>
                    <Fade triggerOnce cascade>
                        <p style={{
                            fontSize: "1.5rem",
                            fontWeight: 700,
                            color: clrs.orange,
                            textTransform: "uppercase"
                        }}>
                            <IntlMessage id={'dataPage.objectNumber1'}/>
                        </p>
                        {
                            isActual ?
                                <Flex onClick={() => {setActual(false)}} gap={10} align={"center"} justify={"center"}
                                      style={{
                                          padding: 15,
                                          backgroundColor: clrs.whiterBlacker2,
                                          borderRadius: 10,
                                          borderBottom: `3px solid ${clrs.whiterBlacker}`,
                                          color: clrs.blacker,
                                          cursor: "pointer"
                                      }}>
                                    <span style={{fontWeight: 700}}>
                                            <IntlMessage id={'archive'}/>
                                        </span>
                                </Flex>
                                :
                                <Flex onClick={() => {setActual(true)}} gap={10} align={"center"} justify={"center"}
                                      style={{
                                          padding: 15,
                                          backgroundColor: clrs.yellow2,
                                          borderRadius: 10,
                                          borderBottom: `3px solid ${clrs.whiterBlacker}`,
                                          color: clrs.blacker,
                                          cursor: "pointer"
                                      }}>
                                    <span style={{fontWeight: 700}}>
                                            <IntlMessage id={'actualData'}/>
                                        </span>
                                </Flex>
                        }
                    </Fade>
                </Flex>
                {
                    isActual ? <DataTable2/> : <ArchiveView/>
                }

            </Flex>
        </Flex>
    );
};


export default DataPage;